import { CellContext } from '@tanstack/react-table';
import { BundleDetails } from '@/types/bundles.types';
import styles from './DescriptionCell.module.css';
import React from 'react';

export const DescriptionCell = ({ row, table, column }: CellContext<BundleDetails, unknown>) => {
  const { original } = row;

  return (
    <div className={styles.tablePage}>
      <span className={styles.name}>{row.original.name}</span>
      <span className={`${styles.internalName} ${styles.block}`}>{row.original.internalName}</span>
    </div>
  );
};
export default DescriptionCell;
